<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 *ngIf="currentMode === payoutMode.CREATE" class="mb-1">{{ employeeName }}'s Payout</h2>
      <h2
        *ngIf="currentMode === payoutMode.REVISE || currentMode === payoutMode.UPDATE"
        class="mb-1"
      >
        {{ currentMode === payoutMode.REVISE ? 'Revise' : 'Update' }} {{ employeeName }}'s Payout
      </h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Contractor</li>
          <li class="breadcrumb-item active" aria-current="page">Payout</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2">
      <a
        href="javascript:void(0);"
        class=""
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        data-bs-original-title="Collapse"
        id="collapse-header"
      >
        <i class="ti ti-chevrons-up"></i>
      </a>
    </div>
  </div>
  <!-- /Breadcrumb -->
  <div [ngSwitch]="currentScreenIndex">
    <ng-container *ngSwitchCase="screens[0]">
      <app-statutory-compliances></app-statutory-compliances>
    </ng-container>
    <ng-container *ngSwitchCase="screens[1]">
      <app-payout-agreement
        *ngIf="currentMode === payoutMode.CREATE"
        (formValuesChanged)="onformValuesChanged($event)"
      ></app-payout-agreement>
      <app-payout-agreement-revision
        *ngIf="currentMode === payoutMode.REVISE || currentMode === payoutMode.UPDATE"
        (formValuesChanged)="onformValuesChanged($event)"
      ></app-payout-agreement-revision>
    </ng-container>
    <ng-container *ngSwitchCase="screens[2]">
      <app-payout-data></app-payout-data>
    </ng-container>
    <ng-container *ngSwitchCase="screens[3]">
      <app-payout-agreement-summary
        *ngIf="currentMode === payoutMode.CREATE"
        (screenNumber)="resetScreen($event)"
      ></app-payout-agreement-summary>
      <app-revised-payout-summary
        *ngIf="currentMode === payoutMode.REVISE || currentMode === payoutMode.UPDATE"
        (saveButtonState)="setNextButtonState($event)"
      ></app-revised-payout-summary>
    </ng-container>
  </div>
  <div>
    <div class="col-xl-9 d-flex justify-content-center">
      <button class="btn btn-light" (click)="previousScreen()">
        {{ currentScreenIndex === 0 ? 'Cancel' : 'Previous' }}
      </button>
      <button class="btn btn-primary" (click)="nextScreen()" [disabled]="nextButtonState">
        {{ currentScreenIndex === screens.length - 1 ? 'Save' : 'Next' }}
      </button>
    </div>
    <div class="col-xl-3 theiaStickySidebar"></div>
  </div>
</div>
